// Ducks 구조 = Action + Reducer
import { createAction, handleActions } from "redux-actions";
import { createPromiseThunk } from "../../util/asyncUtils";

// Action Types
const LOGIN = "login/LOGIN";
const LOGOUT = "login/LOGOUT";
const MODIFY = "login/MODIFY";

// Action Creators
export const login = (loginInfo) => ({ type: LOGIN, loginInfo });
export const logout = () => ({ type: LOGOUT });
export const modify = (modifyInfo) => ({ type: MODIFY, modifyInfo });

// Initial
const loginState = {
    signedIn: false,
    mmbrSeq: "",
    contractNumber: "",
    customerNumber: "",
    mmbrName: "",
    userId: "",
    gradCd: "",
    pedcCd: "",
    homeSchoolYn: "N",
    subscriberType: "",
    bookClubServiceBasicToken: "",
    servicePlatform: "",
    loginType: "",
};

export default function loginReducer(state = loginState, action) {
    switch (action.type) {
        case LOGIN:
            console.log(action.loginInfo);
            return {
                ...state,
                signedIn: true,
                mmbrSeq: action.loginInfo.mmbrSeq,
                contractNumber: action.loginInfo.contractNumber,
                customerNumber: action.loginInfo.customerNumber,
                mmbrName: action.loginInfo.mmbrName,
                userId: action.loginInfo.userId,
                gradCd: action.loginInfo.gradCd,
                pedcCd: action.loginInfo.pedcCd,
                authCode: action.loginInfo.authCode,
                mmbrJoinDt: action.loginInfo.mmbrJoinDt,
                homeSchoolYn: action.loginInfo.homeSchoolYn,
                subscriberType: action.loginInfo.subscriberType,
                authToken: action.loginInfo.token,
                bookClubServiceBasicToken: action.loginInfo.bookClubServiceBasicToken,
                servicePlatform: action.loginInfo.servicePlatform,
                loginType: action.loginInfo.loginType,
            };
        case LOGOUT:
            return {
                ...state,
                signedIn: false,
                mmbrSeq: "",
                contractNumber: "",
                customerNumber: "",
                mmbrName: "",
                userId: "",
                gradCd: "",
                pedcCd: "",
                authCode: "",
                mmbrJoinDt: "",
                homeSchoolYn: "N",
                subscriberType: "",
                servicePlatform: "",
                loginType: "",
            };
        case MODIFY:
            return {
                ...state,
                gradCd: action.modifyInfo.gradCd,
                // pedcCd: action.modifyInfo.pedcCd,
            };
        default:
            return state;
    }
}
